// extracted by mini-css-extract-plugin
export default {"divider":"divider--kId8F"};